import { render } from "./imageMagnifier.vue?vue&type=template&id=50a518a2&scoped=true"
import script from "./imageMagnifier.vue?vue&type=script&lang=js"
export * from "./imageMagnifier.vue?vue&type=script&lang=js"

import "./imageMagnifier.vue?vue&type=style&index=0&id=50a518a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a518a2"]])

export default __exports__